module.exports = __webpack_public_path__ + "img/home.a3ee873e.svg";